export default __webpack_public_path__ + "static/media/logo-eoa-white-2.eba669a5.png";